import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";
import AssignedProductRow from "./AssignedProductRow";
import { GroupedAssignment } from "../measurementTypes";

export default function AssignedProductsSummary({
  assignments,
}: {
  assignments: GroupedAssignment[];
}) {
  return (
    <MDBox mt="20px" pt="16px" borderTop="1px solid #E5E7EB">
      <UiTypography uiVariant="heading-sm">Assigned Products</UiTypography>
      <MDBox mt="12px" display="flex" flexDirection="column" gap="8px">
        {assignments.map((assignment) => (
          <AssignedProductRow key={assignment.productId} assignment={assignment} />
        ))}

        {!assignments.length && (
          <UiTypography uiVariant="body-sm" sx={{ color: "#667085" }}>
            No assigned products yet.
          </UiTypography>
        )}
      </MDBox>
    </MDBox>
  );
}
